export default {
  downtimeUrl: "https://it.kodland.tech",
  startPage: {
    image: "/welcome/quiz_italy_dynamic.png",
    title: "Rispondi a 3 domande e avrai una lezione introduttiva GRATUITA per tuo figlio/a",
    button: "Clicca qui per proseguire",
  },
  successPage: {
    title:
      "Perfetto! Vi chiediamo di scegliere un orario comodo per voi, per prenotare la vostra GRATUITA lezione. Affrettatevi a confermare la vostra presenza per una lezione con un tutor altamente qualificato 🚀",
    subtitle: 'Clicca su "📆 Prenota una lezione" per completare la registrazione',
    button: "📆 Prenota una lezione",
  },
  quizRotateBySteps: {
    1: {
      question: "Quale tipo di pensiero tuo figlio/a usa maggiormente?",
      answers: [
       "🎨 Pensiero creativo",
       "📈 Pensiero analitico",
       "🙌 Misto",
       "🤗 Non so"
       ],
    },
    2: {
      question: "Quali sono le vostre aspettative per imparare?",
      answers: [
        "🧙🏻 Sviluppo del pensiero creativo e spaziale",
        "🖥 Accrescere la motivazione per imparare a programmare",
        "👾 Formazione sulle basi del lavoro con i mondi 3D",
        "🎮 Imparare a lavorare con gli strumenti di sviluppo dei giochi",
        "🫠 Non so"
      ],
    },
    3: {
      question: "Qual è la materia preferita di tuo figlio/a a scuola?",
      answers: [
        "📐 Materie scientifiche",
        "🎨 Creatività",
        "🖥 Informatica",
        "📚 Scienze umane",
        "💙 Ama tutte le materie"
      ],
    },
  },
};

